import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { Manager, ScreenSelection } from 'modules/Device';
import AuthenticatedNavigator from 'navigation/AuthenticatedNavigator';
import { RouteNames } from 'navigation/linkingConfig';
import { DeviceSelectors } from 'store/Device';
import { useAppSelector } from 'store/hooks';
import { UserSelectors } from 'store/User';
import { useManageCustomTranslations } from 'util/localization';

const DeviceStack = createNativeStackNavigator();

export function DeviceNavigator() {
  const registeredDeviceUUID = useAppSelector(
    DeviceSelectors.selectRegisteredUUID,
  );
  const device = useAppSelector(DeviceSelectors.selectDevice);
  const seenScreenSelection = useAppSelector(
    DeviceSelectors.selectSeenScreenSelection,
  );
  const hasAvailableScreens = useAppSelector(
    UserSelectors.selectHasAvailableScreens,
  );
  useManageCustomTranslations();

  return (
    <DeviceStack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      {!registeredDeviceUUID || !device ? (
        <DeviceStack.Screen
          name={RouteNames.Device.Manager}
          component={Manager}
        />
      ) : !seenScreenSelection && hasAvailableScreens ? (
        <DeviceStack.Screen
          name={RouteNames.Device.SelectScreen}
          component={ScreenSelection}
        />
      ) : (
        <DeviceStack.Screen
          name={RouteNames.Device._}
          component={AuthenticatedNavigator}
        />
      )}
    </DeviceStack.Navigator>
  );
}
